// extracted by mini-css-extract-plugin
module.exports = {"channelNote":"_1KsrRW1hyJ35Wg5T","showTranscript":"_1sv3TTTMdI4kkYvc"};